import { ConcreteEncodable } from "./ConcreteEncodable";

import { DataProfileDescriptorImplEncoder } from "../../encoder/DataProfileDescriptorImplEncoder";

import * as CubiqTS from "../../index";
import { DataProfileDescriptor } from "../DataProfileDescriptor";

export class DataProfileDescriptorImpl extends ConcreteEncodable implements DataProfileDescriptor {
  public static enType: string = "com.bcdfx.model.DataProfileDescriptorImpl";

  /*FID=1*/
  public profileType: CubiqTS.DataProfileType;
  /*FID=2*/
  public filterName: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = DataProfileDescriptorImplEncoder.Instance;
    this.setEncodableType(DataProfileDescriptorImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "DataProfileDescriptorImpl[" +
      "profileType=" +
      this.profileType +
      "filterName=" +
      this.filterName +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
